const actions = {
    async AJAX_SEND({rootState,}, body) {
        try {

            var params = {
                route  :  body.route,
                method :  body.method,
            }
            if (body.token !== 'public') {
                params.headers = {'Authorization': `Bearer ${body.token}`}
            }

            if (body.data) {
                params['body'] = body.data
            }

            const data = await rootState.$ajax(params);
            if (data.result) {
                return data
            } else {
                console.log(data)
            }

        } catch (e) {
            console.log(e)
            return e.error
        }
    },
    async GET_BUSINESS_ORDERS({dispatch,rootState},body) {
        return await dispatch('AJAX_SEND',{token:rootState.auth.accessToken ,route:`order/${body}`, method:'GET'});
    },

    async GET_BUSINESS_COURSES_ORDERS({dispatch,rootState}) {
        return await dispatch('ajax/SEND_NEW',{
            token:'token' ,
            route:`orders/courses`,
            method:'GET',
            business : rootState.business.selectedBusiness.alias,
        },{ root : true });
    },

    async EDIT_BUSINESS_COURSE_ORDER({dispatch,rootState} , body) {
        return await dispatch('ajax/SEND_NEW',{
            token:'token' ,
            route:`order/course/edit`,
            method:'POST',
            business : rootState.business.selectedBusiness.alias,
            data : body
        },{ root : true });
    },



    async EDIT_BUSINESS_ORDER({dispatch,rootState},body) {
        return await dispatch('AJAX_SEND',{token:rootState.auth.accessToken ,route:`order/${body.id}`, method:'PUT',data : body.data});
    },
    async GET_LAST_ORDER({dispatch,rootState},body) {
        return await dispatch('AJAX_SEND',{token:rootState.auth.accessToken ,route:`order/${body}/last`, method:'GET'});
    },

}

export default {
    namespaced:true,
    actions,
}